
namespace Matrix.Indexation {
    export class FactIndexationProfileSecurityColumns {
        static columnsKey = 'Indexation.FactIndexationProfileSecurity';
    }
}